const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#9373b1;}.a{opacity:0;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(106 1754)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 32,
  height: 32,
  transform: "translate(-106 -1754)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-516.248 -1815)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(411.248 61)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M427.247,93a16,16,0,1,1,13.166-25.094.688.688,0,0,1-1.132.783,14.623,14.623,0,1,0-1.075,17.994.688.688,0,1,1,1.03.911A16.013,16.013,0,0,1,427.247,93Z",
  transform: "translate(-411.248 -61)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.732 5.324)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M431.351,67.772l4.678,2.876.152-5.489Z",
  transform: "translate(-431.351 -65.159)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(426.559 67.993)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M431.78,84.04a.685.685,0,0,1-.486-.2l-7.882-7.881a.683.683,0,0,1-.2-.486V67.15a.688.688,0,0,1,1.376,0v8.036l7.68,7.679a.689.689,0,0,1-.486,1.175Z",
  transform: "translate(-423.21 -66.463)"
}))));
function SvgModalEditar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalEditar);
export default __webpack_public_path__ + "static/media/modal-editar.3816b3c24dfc9580f6e22e84aa39cbc0.svg";
export { ForwardRef as ReactComponent };